<template>
  <div>
    <p class="cm-mg-p-wzd">2.{{ $t('production.defects_info') }}</p>
    <hr />
    <div class="row">
      <div class="col-3">
        <div class="form-group has-label">
          <label>{{ $t('production.defects_number') }} *</label>
          <el-input-number
            class="shadow-sm"
            v-model.number="model.defect_number"
            @change="handleNumberChange"
            :min="getNumberDefects() || 1"
            :max="30"
          ></el-input-number>
        </div>
      </div>
    </div>
    <div class="row" v-for="index in model.defect_number" :key="index">
      <div class="col-10">
        <fg-input
          :label="index === 1 ? `${$t('production.defect')} *` : ``"
          class="required-name pl-0"
          ref="defectName"
          type="text"
          v-model="model.defectName[index - 1]"
          name="production.defect_row"
          v-validate="modelValidations.defectName"
          :error="getError('production.defect_row', true)"
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-2 pl-4">
        <div class="form-group has-label">
          <label v-if="index === 1">{{ $t('common_words.status') }}</label>
          <el-switch
            v-model="model.enable[index - 1]"
            style="display: block; margin-top: 0.5rem"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinForm from 'src/mixins/forms/mixin-form';
import { Tooltip } from 'element-ui';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      model: {
        defectId: [],
        defectName: [],
        enable: [false],
        defect_number: 1,
      },
      modelValidations: {
        defectName: {
          required: true,
        },
      },
      enable: [],
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinMasters, MixinExport],

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    getNumberDefects() {
      return this.model.defectId.length;
    },
    handleNumberChange() {
      let defectNames = [...this.model.defectName];
      let actEnables = [...this.model.enable];
      this.model.enable = actEnables;

      if (
        this.model.defectName.length > 0 &&
        this.model.defectName.length > this.model.defect_number
      ) {
        this.$set(
          this.model,
          'defectName',
          defectNames.splice(0, this.model.defect_number)
        );
      }
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        this.$emit('fillDefectsCategoryForm', 'secondStep', this.model);
        return res;
      });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading();
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      this.model.enable = [];
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.defect_number = editForm.defects.length;
      editForm.defects.forEach((element) => {
        this.model.defectId.push(element.id);
        this.model.defectName.push(element.name);

        if (element.deleted_at) {
          this.model.enable.push(false);
        } else {
          this.model.enable.push(true);
        }
      });
    }
  },
};
</script>
